import React, { Component } from 'react';
import ConsoleLog from './../../hoc/ConsoleLog/ConsoleLog';

/**
* @desc component for displaying the file upload preview.
* @version 
* @author Lakshmikanth 
*/
class FilePreview extends Component {
  state = {
    src: null,
    type: null
  }

  /**
  * @desc initializing the component
  * @param null
  * @return null
  */
  componentDidMount() {
    this.loadData();
  }

  /**
  * @desc changes preview on changing uploading file
  * @param nextProps
  * @return null
  */
  componentWillReceiveProps(nextProps) {
     this.loadData(nextProps.data)
  }

  /**
  * @desc setting the url and type for image preview
  * @param file data
  * @return null
  */
  loadData(data = this.props.data) {
    if (!data) {
      return;
    }

    let reader = new FileReader();
    let type = null;
    if (data.type.match('text')) {
      type = 'text'
    } else if (data.type.match('image')) {
      type = 'image'
    } else {
      type = data.type
    }
    
    reader.onload = (e) => {
      let src = e.target.result;
      this.setState({
        src,
        type
      });
    }

    if (type === 'text') {
      reader.readAsText(data);
    } else if (type === 'image') {
      reader.readAsDataURL(data);
    } else {
      this.setState({
        src: false,
        type
      });
    }
  }

  /**
  * @desc rendering the file upload preview
  * @param event
  * @return DOM element
  */
  render() {
    // ConsoleLog("data image",this.props.data)
    let preview = <img alt='preview' src={this.state.src} className="image-preview" />;
    return (
      <div className="dropzone-image">
        {preview}
        {!this.props.candidateImageUpload?
        <a className="dropzone-image-remove"
          onClick={this.props.onRemove}>
          ×
        </a>
        :""}
      </div>
    );
  }
}

export default FilePreview;


// WEBPACK FOOTER //
// ./src/hoc/FileUpload/FilePreview.js